import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { UserStore, FilterStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import {LoadingIndicatorMini, PVAPage} from '../components';
import './Home.css';

interface HomeProps extends RouteComponentProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class Home extends React.Component<HomeProps> {
    @computed get logoUrl() {
        if (this.props.FilterStore!.organization && this.props.FilterStore!.organization.logo) {
            return this.props.FilterStore!.organization.logo;
        } else {
            return null;
        }
    }

    @computed get organization() {
        return this.props.FilterStore!.organization;
    }

    @computed get firstName() {
        return `${this.props.UserStore!.userInfo.firstName}`;
    }

    private logo() {
        if (!this.logoUrl) {
            if (this.organization) {
                return (
                    <div className="pva-home-org-name-component">
                        {this.organization.name}
                    </div>
                );
            }
            return <></>;
        }

        const logoImg = (
            <div className={`logo-container ${this.organization && this.organization.logoStyle}`}>
                <img src={this.logoUrl} />
            </div>);

        return (
            <div className="pva-home-org-logo-component">
                {logoImg}
            </div>
        );
    }

    public render() {
        const logoComponent = this.logo();

        return (
            <PVAPage>
                <PVAPage.Header>
                    <div className="title"><span className="greyDark">Welcome</span><span className="user-name">, {this.firstName}</span></div>
                </PVAPage.Header>

                <PVAPage.Body className="home-content-body">
                    <div className="pva-welcome pva-welcome-no-padding">
                        {logoComponent}
                    </div>
                </PVAPage.Body>
                
                <PVAPage.Footer />
            </PVAPage>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.tsx